import Vue from 'vue'
import Vuex from 'vuex'
import userInfo from './modules/userinfo'
import registInfo from './modules/registinfo'
import routekey from './modules/routekey'
import clearCache from './modules/clearCache'
import admitBankAccount from './modules/admitBankAccount'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
Vue.use(Vuex);
let state={}
//const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({	
  modules: {
    userInfo,
    registInfo,
    routekey,
    clearCache,
    admitBankAccount
  },
  actions,
  getters,
  mutations,
  state,
  clearCache
  //strict: debug,
  //plugins: debug ? [createLogger()] : []
})


// WEBPACK FOOTER //
// ./src/store/index.js